module.exports = global["jQuery"] = require("-!/data/fp-commerce/shared-live/tmp/shop/node_modules/expose-loader/index.js?$!./jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ../~/jquery/dist/jquery.js-exposed
 ** module id = 1
 ** module chunks = 19
 **/